<template>
	<div class="index flex1 ">
		<div class="header colFFF f-a jsSB">
			{{ language == 'cn' ? '产品中心' : 'Product Core' }}
			<div style="text-decoration: underline;">
				<i @click="changeLanguage">{{ $store.state.language == 'cn' ? 'En' : '中文' }}</i>
			</div>
		</div>
		<div class="header-pl" style="height: 56px;"></div>
		<div class="tabs">
			<van-tabs v-model="tabs_index">
			  <van-tab :title="item.text" v-for="(item,index) in options"></van-tab>
			</van-tabs>
		</div>

		<div class="list f-a  column">
			<div class="item pointer" v-for="(item, index) in getCategory.list" @click="toDetail(item)">
				<img :src="item.home[0]" alt="" />
				<div class="title f-a-j">{{ item.title }}</div>
				<el-button type="primary" plain style="width: 100%;">查看详情</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import { category_list } from '@/data/data.js';
export default {
	name:'index',
	props: {
		index: {
			type: Number,
			default: 1
		}
	},
	data() {
		return {
			category_list,
			icon: require('@/assets/image/精油水薰衣草/1.jpg'),
			options: [],
			options_value: 0,
			tabs_index:0
		};
	},
	created() {
		let id = this.$route.params.id;
		category_list.forEach((item1, index1) => {
			this.options.push({
				text: item1.title,
				value: index1
			});
		});
	},
	watch:{
		tabs_index(val){
			this.tabsChange(val)
		}
	},
	computed: {
		getCategory() {
			return this.category_list[this.index];
		},
		language() {
			return this.$store.state.language;
		}
	},
	methods: {
		toDetail(item) {
			this.$router.push({
				path: `/category/detail/${item.id}`
			});
		},
		changeLanguage() {
			this.$store.state.language = this.$store.state.language == 'cn' ? 'en' : 'cn';
		},
		tabsChange(index) {
			this.options_value = index;
			console.log(index);
			this.$parent.tabsChange(index);
		}
	}
};
</script>

<style lang="less" scoped>
/deep/.van-dropdown-menu__bar {
	opacity: 0;
}

.index {
	padding-top: 0;
	box-sizing: border-box;
	.header {
		position: fixed;
		top: 0;
		box-sizing: border-box;
		width: 100%;
		z-index: 99999;
		line-height: 56px;
		height: 56px;
		padding: 0 14px;
		background-color: #b3c0d1;
	}
	.list {
		padding: 0 30px;
		.item {
			border: 1px solid #ebeef5;
			width: 100%;
			margin-top: 18px;
			border-radius: 4px;
			transition: 0.5s;
			box-sizing: border-box;
			padding: 12px;
			img {
				display: block;
				width: 100%;
				height: 300px;
				margin: 0 auto;
			}
			.title {
				height: 40px;
				line-height: 40px;
			}
			.el-button{
				width: 100%;
				letter-spacing: 1px;
				margin-top: 10px;
			}
		}
		.item:nth-child(n + 2) {
		}
	}
}
</style>
